import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import Modal from 'modules/common/components/Modal';
import withForm from 'modules/common/hoc/withForm';
import SecuredImage from 'modules/common/components/SecuredImage';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';

function ImageContainer({
  fetching,
  createLowerCaseInput,
  info,
  page,
  formData,
  setFormData,
  uploadNewImage,
  updateNewImage,
  uploadingNew,
  getBirthCertificateList,
  showBirthCertificate,
  syncToEs,
}) {
  const setModal = useContext(ModalContext);
  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const OnSetFormData = () => {
    const images = _.get(info, 'included.images');
    let getImageType = '';
    if (images.length > 0) {
      getImageType = images.filter((el) => {
        return el.attributes.page === page;
      });
    }
    setFormData({
      ...formData,
      hasImage: getImageType.length,
      volume: _.get(getImageType, '0.attributes.volume') || '',
      image_id: _.get(getImageType, '0.id') || '',
      image: _.get(getImageType, '0.attributes.image_url') || '',
      id: _.get(info, 'id') || '',
    });
  };

  useEffect(() => {
    OnSetFormData();
  }, []);

  const onUpload = (e) => {
    e.preventDefault();

    const reader = new FileReader();
    const file = e.target.files[0];

    reader.onloadend = () => {
      setFormData({
        ...formData,
        image: reader.result,
        file,
        imagePreviewUrl: reader.result,
      });
    };

    reader.readAsDataURL(file);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append('image', _.get(formData, 'file'));
    data.append('volume', _.get(formData, 'volume'));
    data.append('page', page);

    if (!_.get(formData, 'hasImage')) {
      uploadNewImage(_.get(formData, 'id'), data, () => {
        getBirthCertificateList();
        showBirthCertificate(_.get(formData, 'id'));
        syncToEs({ id: _.get(formData, 'id') });
        setModal({ isOpen: false });
      });
    } else {
      data.append('_method', 'put');
      updateNewImage(
        _.get(formData, 'id'),
        _.get(formData, 'image_id'),
        data,
        () => {
          getBirthCertificateList();
          showBirthCertificate(_.get(formData, 'id'));
          syncToEs({ id: _.get(formData, 'id') });
          setModal({ isOpen: false });
        }
      );
    }
  };

  const getButtonLabel = (flag) => {
    return flag ? `Re-upload` : `Upload`;
  };

  return (
    <Modal.Body>
      <form onSubmit={handleSubmit}>
        <div className="container">
          <div className="row ">
            <div className="col-4 form-group">
              {createLowerCaseInput(
                { key: 'volume', label: 'Volume:' },
                { required: true, placeholder: 'Volume' }
              )}
            </div>
          </div>
          <div className="row d-flex justify-content-center">
            <div className="col-12 mb-2">
              <input
                required
                type="file"
                className="file-elip btn border border-primary btn-light btn-round font-weight-bold px-4 ml-auto"
                onChange={onUpload}
              />
            </div>
            <div className="col-12 bc-image ">
              <SecuredImage
                ref={null}
                onContextMenu={(e) => {
                  e.preventDefault();
                  return false;
                }}
                alt="Image not found"
                src={_.get(formData, 'image') || ImagePlaceholder}
              />
            </div>
          </div>
          <div className="row d-flex justify-content-center">
            <button
              disabled={fetching}
              type="button"
              onClick={closeModal}
              className="mt-3 btn btn-dark mr-5 "
            >
              <span className="font-weight-bold">Close</span>
            </button>
            <button
              disabled={uploadingNew}
              type="submit"
              className="mt-3 btn btn-primary cms-bg-color-primary"
            >
              <span className="font-weight-bold">
                {uploadingNew ? (
                  <i className="fa fa-spin fa-spinner" />
                ) : (
                  getButtonLabel(_.get(formData, 'hasImage'))
                )}
              </span>
            </button>
          </div>
        </div>
      </form>
    </Modal.Body>
  );
}

ImageContainer.propTypes = {
  fetching: PropTypes.bool.isRequired,
  uploadingNew: PropTypes.bool.isRequired,
  page: PropTypes.string.isRequired,
  getBirthCertificateList: PropTypes.instanceOf(Function).isRequired,
  info: PropTypes.instanceOf(Object).isRequired,
  createLowerCaseInput: PropTypes.instanceOf(Function).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  uploadNewImage: PropTypes.instanceOf(Function).isRequired,
  updateNewImage: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  showBirthCertificate: PropTypes.instanceOf(Function).isRequired,
  syncToEs: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  fetching: api.loading.indexOf(c.GET_IMAGE) > -1,
  uploadingNew: api.loading.indexOf(c.UPLOAD_NEW_IMAGE) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ImageContainer);
